<template>
  <div class="card-game" @click="goToLink">
    <div class="card-game__cover">
      <img v-if="editorial.picture != ''" :src="getUrlPicture(editorial.picture)" alt="">
      <img v-else src="@/assets/fanfestlive.jpg" alt="">
    </div>
    <div class="card-game__content">
      <h2 class="card-game__content__title">{{editorial.title}}</h2>
      <p class="card-game__content__description">{{editorial.description}}</p>
      <div class="card-game__content__action">
        <h3>{{editorial.callToActionText}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editorial: Object
  },
  computed: {
    isApp() {
      return window["cordova"] != undefined
    }
  },
  methods: {
    getUrlPicture(picture) {
      return `${process.env.VUE_APP_CDN_URL_GAME_PICTURES}${picture}`
    },
    goToLink() {
      window.open(`${this.editorial.callToActionLink}`, '_system');
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';
</style>